import styled from "styled-components";
import { themeModules } from "../../theme/theme.js"

const Container=styled.div`
	width:95%;
	border-radius:10px;
	display:flex;
	align-items:center;
	background-color:${themeModules.panel};
	margin-bottom:15px;
	padding:15px;
`

export default function subPanel(props){
	let { child }= props
	return(
		<Container>			
      			{child}	
    	</Container>

		)
}